import { V_FORM_ENUM } from '@/CommonDP/VForm/utils';
const JY_DIR_ENUM = {
  TYPE: 'jy-dir',
  LABEL: '存放目录'
};
export const DIR_FOLDER_LIMIT = {
  NONE: {
    LABEL: '不限定',
    VALUE: 'none'
  },
  LAST: {
    LABEL: '最末级目录',
    VALUE: 'leaf'
  },
  NOT_SYS: {
    LABEL: '非系统目录',
    VALUE: 'notSys'
  }
};
export const DIR_ROOT = {
  NONE: {
    LABEL: '不限定',
    VALUE: '0'
  },
  ENTERPRISE_DOC: {
    LABEL: '企业文档',
    VALUE: 'EnterpriseDoc'
  },
  HIDDEN: {
    LABEL: '隐藏目录',
    VALUE: 'folderhide000001'
  },
  TIZI: {
    LABEL: '提资区',
    VALUE: '1630981803194'
  },
  PROOFREAD: {
    LABEL: '校审区',
    VALUE: '1630981811371'
  },
  DESIGN: {
    LABEL: '设计区',
    VALUE: '1630981681702'
  }
};
export const schema = {
  group: V_FORM_ENUM.custom,
  type: JY_DIR_ENUM.TYPE,
  icon: 'tree',
  label: JY_DIR_ENUM.LABEL,
  formItemFlag: true,
  component: require('./index.vue').default,
  options: {
    name: '',
    requiredHint: ' ',
    labelHidden: false,
    labelWidth: '',
    required: false,
    disabled: false,
    position: '',
    labelAlign: '',
    columnWidth: '200px',
    customClass: '',
    labelWrap: false, // 自动换行
    hidden: false,

    setting: '',
    specKey: '',
    folderId: '0',
    limitFolder: 'none',
    folderName: '',
    folderNamePath: '',
    folderIdPath: '',
    onMounted: '',
    onChange: '',
    onInitAndUpdate: ""
  },
  props() {
    return {
      setting: () => import('./setting.vue')
    };
  },
  // 事件名 :[事件参数]
  events() {
    return {
      onMounted: [],
      onChange: ['value', 'label']
    };
  },
  getSFC: () => {
    return '<div></div>';
  }
};
